import { useEffect } from 'react';
import { api } from '@/lib/api';
import { useAuthStore } from '@/stores/auth';
import { useSessionBlocked } from '@/stores/sessionTransition';

let inFlight: { revision: number; request: Promise<void> } | null = null;

function requestSocketToken() {
  const revision = useAuthStore.getState().sessionRevision;
  if (inFlight?.revision === revision) return;
  const request = api
    .post('/auth/socket-token')
    .then((res) => {
      if (useAuthStore.getState().sessionRevision === revision) useAuthStore.getState().setSocketToken(res.data.token);
    })
    .catch(() => {})
    .finally(() => {
      if (inFlight?.request === request) inFlight = null;
    });
  inFlight = { revision, request };
}

/**
 * RC-065: o token do tempo real não fica salvo no navegador; depois de recarregar a aba, quem
 * precisa do socket pede um. Um pedido só por sessão, mesmo com o AppShell, a Agenda, o CRM e
 * as Conversas pedindo juntos — dois tokens diferentes derrubariam a conexão única.
 */
export function useSocketToken(): string | null {
  const paused = useSessionBlocked();
  const socketToken = useAuthStore((s) => s.socketToken);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  useEffect(() => {
    if (!paused && isAuthenticated && !socketToken) requestSocketToken();
  }, [paused, isAuthenticated, socketToken]);

  return socketToken;
}
